import { render, staticRenderFns } from "./PivotGridView.vue?vue&type=template&id=22391159&"
import script from "./PivotGridView.vue?vue&type=script&lang=js&"
export * from "./PivotGridView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports